import 'firebase/database';
import 'firebase/auth';
import 'firebase/storage';

import {
    GetDateString,
    MinutesPassed
} from './other/DateFunctions';
import {
    GetDistance,
    GetTripDistance
} from './other/GeoFunctions';
import React, { createContext } from 'react';
import {
    acceptTask,
    bookingReq,
    cancelTask,
    fetchTasks
} from './actions/taskactions';
import {
    addBooking,
    addRentalBooking,
    clearBooking,
    editBooking,
} from './actions/bookingactions';
import {
    addCarType,
    deleteCarType,
    editCarType,
    fetchCarTypes
} from './actions/cartypeactions';
import {
    addDriverStatus,
    editDriverStatus,
    fetchDriverStatus,
    filterDriverStatus
} from './actions/driverstatusaction';
import {
    addLocalFare,
    addOutstationFare,
    addRentalFare,
    clearFare,
    fetchFare,
    updateFare
} from './actions/fareactions';
import {
    addOperator,
    deleteOperator,
    editOperator,
    fetchOperators
} from './actions/operatoractions';
import {
    addToWallet,
    clearMessage,
    fetchPaymentMethods,
    updateWalletBalance
} from './actions/paymentactions';
import {
    addTransaction,
    deleteTransaction,
    editTransaction,
    fetchTransactions
} from './actions/transactionactions';
import {
    addUser,
    editUser,
    fetchDrivers,
    fetchUsers,
    uploadImage,
    deleteUser,
} from './actions/usersactions';
import {
    addVehicle,
    deleteVehicle,
    driverEditVehicle,
    editVehicle,
    fetchVehicles,
    updateVehicleCommission
} from './actions/vehicleactions';
import {
    appleSignIn,
    checkOperatorExists,
    checkOtp,
    checkUserExists,
    checkVehicleExists,
    clearLoginError,
    // deleteUser,
    emailSignUp,
    facebookSignIn,
    fetchUser,
    mobileCheckOtp,
    mobileSignIn,
    mobileSignUp,
    mobileUserCreate,
    monitorProfileChanges,
    requestPhoneOtpDevice,
    sendResetMail,
    signIn,
    signOut,
    updateDriverStatus,
    updatePassword,
    updateProfile,
    updateProfileImage,
    updatePushToken,
    validateReferer,
    resetPassword
} from './actions/authactions';
import {
    cancelBooking,
    driverCancelBooking,
    fetchAllBookings,
    fetchBookings,
    updateBooking,
    fetchRequestedDrivers,
    getTrackingRecord
} from './actions/bookinglistactions';
import {
    clearDriverEstimate,
    clearEstimate,
    clearRentalEstimate,
    getDriverEstimate,
    getEstimate,
    getRentalEstimate,
} from './actions/estimateactions';
import {
    clearSettingsViewError,
    editSettings,
    fetchSettings
} from './actions/settingsactions';
import {
    clearTripPoints,
    updatSelPointType,
    updateTripCar,
    updateTripDrop,
    updateTripPickup
} from './actions/tripactions';
import {
    completeWithdraw,
    fetchWithdraws
} from './actions/withdrawactions';
import {
    editCancellationReason,
    fetchCancelReasons,
    addCancellationReason,
    deleteCancellationReason
} from './actions/cancelreasonactions';
import {
    addNotifications,
    deleteNotifications,
    editNotifications,
    fetchNotifications,
    sendNotification
} from './actions/notificationactions';
import {
    editPromo,
    fetchPromos,
    addPromo,
    deletePromo
} from './actions/promoactions';
import {
    fetchAddressfromCoords,
    fetchCoordsfromPlace,
    getDriveTime,
    getRouteDetails
} from './other/GoogleAPIFunctions';
import {
    fetchBookingLocations,
    stopLocationFetch
} from './actions/locationactions';
import {
    fetchChatMessages,
    sendMessage,
    stopFetchMessages
} from './actions/chatactions';

// import app from 'firebase/app';
import { fetchDriverEarnings } from './actions/driverearningaction';
import { fetchEarningsReport } from './actions/earningreportsaction';
import { store } from './store/store';
import firebase from 'firebase/compat/app';

const FirebaseContext = createContext(null);

// const FirebaseProvider = ({ children }) => {
//     let firebase = {
//         app: null,
//         database: null,
//         auth: null,
//         storage: null
//     }

//     if (!app.apps.length) {
//         app.initializeApp(FirebaseConfig);
//         firebase = {
//             app: app,
//             database: app.database(),
//             auth: app.auth(),
//             storage: app.storage(),
//             authRef: app.auth(),
//             facebookProvider: new app.auth.FacebookAuthProvider(),
//             googleProvider: new app.auth.GoogleAuthProvider(),
//             appleProvider: new app.auth.OAuthProvider('apple.com'),
//             phoneProvider: new app.auth.PhoneAuthProvider(),
//             RecaptchaVerifier: app.auth.RecaptchaVerifier,
//             captchaGenerator: (element) => new app.auth.RecaptchaVerifier(element),
//             facebookCredential: (token) => app.auth.FacebookAuthProvider.credential(token),
//             googleCredential: (idToken) => app.auth.GoogleAuthProvider.credential(idToken),
//             mobileAuthCredential: (verificationId, code) => app.auth.PhoneAuthProvider.credential(verificationId, code),
//             usersRef: app.database().ref("users"),
//             transactionsRef: app.database().ref("transactions"),
//             operatorsRef: app.database().ref("operators"),
//             vehiclesRef: app.database().ref("vehicles"),
//             bookingRef: app.database().ref("bookings"),
//             fareRef: app.database().ref("fare"),
//             cancelreasonRef: app.database().ref("cancel_reason"),
//             driverstatusRef: app.database().ref("driver_status"),
//             settingsRef: app.database().ref("settings"),
//             carTypesRef: app.database().ref("rates/car_type"),
//             promoRef: app.database().ref("offers"),
//             bookingCancelRef: app.database().ref("cancel_bookings"),
//             promoEditRef: (id) => app.database().ref("offers/" + id),
//             notifyRef: app.database().ref("notifications/"),
//             fareListRef: app.database().ref('fare'),
//             bookingRequestRef: (uid) => app.database().ref('bookingRequestedDrivers').orderByChild('bookingId').equalTo(uid),

//             // fullBookingRequestRef: firebase.database().ref("fullBookingRequestedDrivers"),
//             fullBookingRequestRef: (uid) => app.database().ref("fullBookingRequestedDrivers").orderByChild('bookingId').equalTo(uid),


//             notifyEditRef: (id) => app.database().ref("notifications/" + id),
//             singleUserRef: (uid) => app.database().ref("users/" + uid),
//             singleFareRef: (uid) => app.database().ref("fare/" + uid),
//             imageStorageRef: (url) => app.storage().refFromURL(url),
//             singleVehicleRef: (uid) => app.database().ref("vehicles/" + uid),
//             singleTransactionRef: (uid) => app.database().ref("transactions/" + uid),
//             singleCarTypesRef: (uid) => app.database().ref("rates/car_type/" + uid),
//             singleOperatorRef: (uid) => app.database().ref("operators/" + uid),
//             singleDriverStatusRef: (uid) => app.database().ref("driver_status/" + uid),
//             singleBookingRequestRef: (booking) => app.database().ref("bookingRequestedDrivers/" + booking),
//             profileImageRef: (uid) => app.storage().ref(`users/${uid}/profileImage`),
//             driverDocsRef: (uid, timestamp) => app.storage().ref(`users/${uid}/driverDocuments/${timestamp}/`),
//             operatorDocsRef: (uid, timestamp) => app.storage().ref(`users/${uid}/operatorDocuments/${timestamp}/`),
//             carTypeDocsRef: (type, role) => app.storage().ref(`rates/car_type/${type}/${role}/`),
//             vehiclesDocsRef: (type, timestamp) => app.storage().ref(`vehicles/${type}/${timestamp}/`),
//             singleBookingRef: (bookingKey) => app.database().ref("bookings/" + bookingKey),
//             requestedDriversRef: (bookingKey) => app.database().ref("bookings/" + bookingKey + "/requestedDrivers"),
//             walletBalRef: (uid) => app.database().ref("users/" + uid + "/walletBalance"),
//             walletHistoryRef: (uid) => app.database().ref("users/" + uid + "/walletHistory"),
//             referralIdRef: (referralId) => app.database().ref("users").orderByChild("referralId").equalTo(referralId),
//             trackingRef: (bookingId) => app.database().ref('tracking/' + bookingId),
//             tasksRef: () => app.database().ref('bookings').orderByChild('status').equalTo('NEW'),
//             singleTaskRef: (uid, bookingId) => app.database().ref("bookings/" + bookingId + "/requestedDrivers/" + uid),
//             bookingListRef: (uid, role) =>
//                 role == 'rider' ? app.database().ref('bookings').orderByChild('customer').equalTo(uid) :
//                     (role == 'driver' ?
//                         app.database().ref('bookings').orderByChild('driver').equalTo(uid)
//                         :
//                         (role == 'fleetadmin' ?
//                             app.database().ref('bookings').orderByChild('fleetadmin').equalTo(uid)
//                             : app.database().ref('bookings')
//                         )
//                     ),
//             chatRef: (bookingId) => app.database().ref('chats/' + bookingId + '/messages'),
//             withdrawRef: app.database().ref('withdraws/'),

//             api: {
//                 MinutesPassed: MinutesPassed,
//                 GetDateString: GetDateString,

//                 fetchCoordsfromPlace: fetchCoordsfromPlace,
//                 fetchAddressfromCoords: fetchAddressfromCoords,
//                 getDriveTime: getDriveTime,
//                 getRouteDetails: getRouteDetails,

//                 GetDistance: GetDistance,
//                 GetTripDistance: GetTripDistance,
//                 saveUserLocation: (uid, location) => app.database().ref('users/' + uid + '/location').set(location),
//                 saveTracking: (bookingId, location) => app.database().ref('tracking/' + bookingId).push(location),

//                 validateReferer: validateReferer,
//                 checkUserExists: checkUserExists,
//                 checkVehicleExists: checkVehicleExists,
//                 checkOperatorExists: checkOperatorExists,
//                 fetchUser: () => (dispatch) => fetchUser()(dispatch)(firebase),
//                 fetchOperator: () => (dispatch) => fetchOperator()(dispatch)(firebase),
//                 fetchVehicle: () => (dispatch) => fetchVehicle()(dispatch)(firebase),
//                 emailSignUp: (data) => emailSignUp(data)(firebase),
//                 mobileSignUp: (data) => mobileSignUp(data)(firebase),
//                 mobileUserCreate: (data) => mobileUserCreate(data)(firebase),
//                 mobileCheckOtp: (data) => mobileCheckOtp(data)(firebase),
//                 checkOtp: (code, otp, credential) => (dispatch) => checkOtp(code, otp, credential)(dispatch)(firebase),

//                 mobileSignIn: (verficationId, code) => (dispatch) => mobileSignIn(verficationId, code)(dispatch)(firebase),
//                 updatePassword: (password) => (dispatch) => updatePassword(password)(dispatch)(firebase),
//                 signIn: (email, password) => (dispatch) => signIn(email, password)(dispatch)(firebase),
//                 facebookSignIn: (token) => (dispatch) => facebookSignIn(token)(dispatch)(firebase),
//                 appleSignIn: (credentialData) => (dispatch) => appleSignIn(credentialData)(dispatch)(firebase),
//                 signOut: () => (dispatch) => signOut()(dispatch)(firebase),
//                 filterDriverStatus: (email, fromdate, todate) => (dispatch) => filterDriverStatus(email, fromdate, todate)(dispatch)(firebase),
//                 updateProfile: (userAuthData, updateData) => (dispatch) => updateProfile(userAuthData, updateData)(dispatch)(firebase),
//                 updateDriverStatus: (statusData, updateData) => (dispatch) => updateDriverStatus(statusData, updateData)(dispatch)(firebase),
//                 monitorProfileChanges: () => (dispatch) => monitorProfileChanges()(dispatch)(firebase),
//                 clearLoginError: () => (dispatch) => clearLoginError()(dispatch)(firebase),
//                 addBooking: (bookingData) => (dispatch) => addBooking(bookingData)(dispatch)(firebase),
//                 addRentalBooking: (bookingData) => (dispatch) => addRentalBooking(bookingData)(dispatch)(firebase),
//                 editBooking: (oldbookingData, bookingData) => (dispatch) => editBooking(oldbookingData, bookingData)(dispatch)(firebase),
//                 clearBooking: () => (dispatch) => clearBooking()(dispatch)(firebase),
//                 fetchFare: () => (dispatch) => fetchFare()(dispatch)(firebase),
//                 deleteFare: (uid) => (dispatch) => clearFare(uid)(dispatch)(firebase),
//                 updateFare: (fareData) => (dispatch) => updateFare(fareData)(dispatch)(firebase),
//                 fetchBookings: (uid, role) => (dispatch) => fetchBookings(uid, role)(dispatch)(firebase),
//                 fetchAllBookings: () => (dispatch) => fetchAllBookings()(dispatch)(firebase),
//                 updateBooking: (booking) => (dispatch) => updateBooking(booking)(dispatch)(firebase),
//                 cancelBooking: (data) => (dispatch) => cancelBooking(data)(dispatch)(firebase),
//                 fetchCancelReasons: () => (dispatch) => fetchCancelReasons()(dispatch)(firebase),
//                 editCancellationReason: (reasons, method) => (dispatch) => editCancellationReason(reasons, method)(dispatch)(firebase),
//                 fetchCarTypes: () => (dispatch) => fetchCarTypes()(dispatch)(firebase),
//                 // editCarType: (carTypes, method) => (dispatch) => editCarType(carTypes, method)(dispatch)(firebase),
//                 editCarType: (id, carTypes) => (dispatch) => editCarType(id, carTypes)(dispatch)(firebase),
//                 addCarType: (carTypesData) => (dispatch) => addCarType(carTypesData)(dispatch)(firebase),
//                 getEstimate: (bookingData) => (dispatch) => getEstimate(bookingData)(dispatch)(firebase),
//                 clearEstimate: () => (dispatch) => clearEstimate()(dispatch)(firebase),
//                 getRentalEstimate: (bookingData) => (dispatch) => getRentalEstimate(bookingData)(dispatch)(firebase),
//                 clearRentalEstimate: () => (dispatch) => clearRentalEstimate()(dispatch)(firebase),
//                 clearDriverEstimate: () => (dispatch) => clearDriverEstimate()(dispatch)(firebase),
//                 getDriverEstimate: (bookingData) => (dispatch) => getDriverEstimate(bookingData)(dispatch)(firebase),
//                 fetchSettings: () => (dispatch) => fetchSettings()(dispatch)(firebase),
//                 editSettings: (settings) => (dispatch) => editSettings(settings)(dispatch)(firebase),
//                 clearSettingsViewError: () => (dispatch) => clearSettingsViewError()(dispatch)(firebase),
//                 sendResetMail: (email) => (dispatch) => sendResetMail(email)(dispatch)(firebase),
//                 fetchDriverEarnings: (uid, role) => (dispatch) => fetchDriverEarnings(uid, role)(dispatch)(firebase),
//                 fetchEarningsReport: () => (dispatch) => fetchEarningsReport()(dispatch)(firebase),
//                 fetchNotifications: () => (dispatch) => fetchNotifications()(dispatch)(firebase),
//                 editNotifications: (notifications, method) => (dispatch) => editNotifications(notifications, method)(dispatch)(firebase),
//                 sendNotification: (notification) => (dispatch) => sendNotification(notification)(dispatch)(firebase),
//                 fetchPromos: () => (dispatch) => fetchPromos()(dispatch)(firebase),
//                 editPromo: (promos, method) => (dispatch) => editPromo(promos, method)(dispatch)(firebase),
//                 fetchUsers: () => (dispatch) => fetchUsers()(dispatch)(firebase),
//                 fetchTransactions: () => (dispatch) => fetchTransactions()(dispatch)(firebase),
//                 fetchOperators: () => (dispatch) => fetchOperators()(dispatch)(firebase),
//                 fetchVehicles: () => (dispatch) => fetchVehicles()(dispatch)(firebase),
//                 fetchDriverStatus: () => (dispatch) => fetchDriverStatus()(dispatch)(firebase),
//                 fetchDrivers: () => (dispatch) => fetchDrivers()(dispatch)(firebase),
//                 addLocalFare: (faredata) => (dispatch) => addLocalFare(faredata)(dispatch)(firebase),
//                 addOutstationFare: (faredata) => (dispatch) => addOutstationFare(faredata)(dispatch)(firebase),
//                 addRentalFare: (faredata) => (dispatch) => addRentalFare(faredata)(dispatch)(firebase),
//                 addUser: (userdata) => (dispatch) => addUser(userdata)(dispatch)(firebase),
//                 uploadImage: (userdata) => (dispatch) => uploadImage(userdata)(dispatch)(firebase),
//                 addOperator: (operatordata) => (dispatch) => addOperator(operatordata)(dispatch)(firebase),
//                 addTransaction: (transdata) => (dispatch) => addTransaction(transdata)(dispatch)(firebase),
//                 addVehicle: (vehicledata) => (dispatch) => addVehicle(vehicledata)(dispatch)(firebase),
//                 addDriverStatus: (statusdata) => (dispatch) => addDriverStatus(statusdata)(dispatch)(firebase),
//                 editDriverStatus: (email) => (dispatch) => editDriverStatus(email)(dispatch)(firebase),
//                 editUser: (id, user) => (dispatch) => editUser(id, user)(dispatch)(firebase),
//                 editTransaction: (id, trans) => (dispatch) => editTransaction(id, trans)(dispatch)(firebase),
//                 editOperator: (id, operator) => (dispatch) => editOperator(id, operator)(dispatch)(firebase),
//                 editVehicle: (id, vehicle) => (dispatch) => editVehicle(id, vehicle)(dispatch)(firebase),
//                 updateVehicleCommission: (id, vehicle) => (dispatch) => updateVehicleCommission(id, vehicle)(dispatch)(firebase),
//                 driverCancelBooking: (data) => (dispatch) => driverCancelBooking(data)(dispatch)(firebase),
//                 driverEditVehicle: (id, vehicle) => (dispatch) => driverEditVehicle(id, vehicle)(dispatch)(firebase),
//                 updatePushToken: (userAuthData, token, platform) => (dispatch) => updatePushToken(userAuthData, token, platform)(dispatch)(firebase),
//                 updateProfileImage: (userAuthData, imageBlob) => (dispatch) => updateProfileImage(userAuthData, imageBlob)(dispatch)(firebase),
//                 requestPhoneOtpDevice: (phoneNumber, appVerifier) => (dispatch) => requestPhoneOtpDevice(phoneNumber, appVerifier)(dispatch)(firebase),
//                 deleteUser: (uid) => (dispatch) => deleteUser(uid)(dispatch)(firebase),
//                 deleteOperator: (uid) => (dispatch) => deleteOperator(uid)(dispatch)(firebase),
//                 deleteTransaction: (uid) => (dispatch) => deleteTransaction(uid)(dispatch)(firebase),
//                 deleteVehicle: (uid, driverId) => (dispatch) => deleteVehicle(uid, driverId)(dispatch)(firebase),
//                 deleteCarType: (uid) => (dispatch) => deleteCarType(uid)(dispatch)(firebase),
//                 fetchPaymentMethods: () => (dispatch) => fetchPaymentMethods()(dispatch)(firebase),
//                 addToWallet: (uid, amount) => (dispatch) => addToWallet(uid, amount)(dispatch)(firebase),
//                 updateWalletBalance: (balance, details) => (dispatch) => updateWalletBalance(balance, details)(dispatch)(firebase),
//                 clearMessage: () => (dispatch) => clearMessage()(dispatch)(firebase),
//                 updateTripPickup: (pickupAddress) => (dispatch) => updateTripPickup(pickupAddress)(dispatch)(firebase),
//                 updateTripDrop: (dropAddress) => (dispatch) => updateTripDrop(dropAddress)(dispatch)(firebase),
//                 updateTripCar: (selectedCar) => (dispatch) => updateTripCar(selectedCar)(dispatch)(firebase),
//                 updatSelPointType: (selection) => (dispatch) => updatSelPointType(selection)(dispatch)(firebase),
//                 clearTripPoints: () => (dispatch) => clearTripPoints()(dispatch)(firebase),
//                 fetchTasks: () => (dispatch) => fetchTasks()(dispatch)(firebase),
//                 acceptTask: (userAuthData, task) => (dispatch) => acceptTask(userAuthData, task)(dispatch)(firebase),
//                 cancelTask: (bookingId) => (dispatch) => cancelTask(bookingId)(dispatch)(firebase),
//                 fetchBookingLocations: (bookingId) => (dispatch) => fetchBookingLocations(bookingId)(dispatch)(firebase),
//                 stopLocationFetch: (bookingId) => (dispatch) => stopLocationFetch(bookingId)(dispatch)(firebase),
//                 fetchChatMessages: (bookingId) => (dispatch) => fetchChatMessages(bookingId)(dispatch)(firebase),
//                 sendMessage: (data) => (dispatch) => sendMessage(data)(dispatch)(firebase),
//                 stopFetchMessages: (bookingId) => (dispatch) => stopFetchMessages(bookingId)(dispatch)(firebase),
//                 fetchWithdraws: () => (dispatch) => fetchWithdraws()(dispatch)(firebase),
//                 bookingReq: (id) => (dispatch) => bookingReq(id)(dispatch)(firebase),
//                 completeWithdraw: (entry) => (dispatch) => completeWithdraw(entry)(dispatch)(firebase)
//             }
//         }
//     }

//     return (
//         <FirebaseContext.Provider value={firebase}>
//             {children}
//         </FirebaseContext.Provider>
//     )
// }

const Firebase = {
    // app: firebase,
    // database: firebase.database(),
    // auth: firebase.auth(),
    // storage: firebase.storage(),
    // authRef: firebase.auth(),
    // facebookProvider: new firebase.auth.FacebookAuthProvider(),
    // googleProvider: new firebase.auth.GoogleAuthProvider(),
    // appleProvider: new firebase.auth.OAuthProvider('apple.com'),
    // phoneProvider: new firebase.auth.PhoneAuthProvider(),
    // RecaptchaVerifier: firebase.auth.RecaptchaVerifier,
    // captchaGenerator: (element) => new firebase.auth.RecaptchaVerifier(element),
    // facebookCredential: (token) => firebase.auth.FacebookAuthProvider.credential(token),
    // googleCredential: (idToken) => firebase.auth.GoogleAuthProvider.credential(idToken),
    // mobileAuthCredential: (verificationId, code) => firebase.auth.PhoneAuthProvider.credential(verificationId, code),
    // usersRef: firebase.database().ref("users"),
    // transactionsRef: firebase.database().ref("transactions"),
    // operatorsRef: firebase.database().ref("operators"),
    // vehiclesRef: firebase.database().ref("vehicles"),
    // bookingRef: firebase.database().ref("bookings"),
    // fareRef: firebase.database().ref("fare"),
    // cancelreasonRef: firebase.database().ref("cancel_reason"),
    // driverstatusRef: firebase.database().ref("driver_status"),
    // settingsRef: firebase.database().ref("settings"),
    // carTypesRef: firebase.database().ref("rates/car_type"),
    // promoRef: firebase.database().ref("offers"),
    // bookingCancelRef: firebase.database().ref("cancel_bookings"),
    // promoEditRef: (id) => firebase.database().ref("offers/" + id),
    // notifyRef: firebase.database().ref("notifications/"),
    // fareListRef: firebase.database().ref('fare'),
    // bookingRequestRef: (uid) => firebase.database().ref('bookingRequestedDrivers').orderByChild('bookingId').equalTo(uid),

    // // fullBookingRequestRef: firebase.database().ref("fullBookingRequestedDrivers"),
    // fullBookingRequestRef: (uid) => firebase.database().ref("fullBookingRequestedDrivers").orderByChild('bookingId').equalTo(uid),


    // notifyEditRef: (id) => firebase.database().ref("notifications/" + id),
    // singleUserRef: (uid) => firebase.database().ref("users/" + uid),
    // singleFareRef: (uid) => firebase.database().ref("fare/" + uid),
    // imageStorageRef: (url) => firebase.storage().refFromURL(url),
    // singleVehicleRef: (uid) => firebase.database().ref("vehicles/" + uid),
    // singleTransactionRef: (uid) => firebase.database().ref("transactions/" + uid),
    // singleCarTypesRef: (uid) => firebase.database().ref("rates/car_type/" + uid),
    // singleOperatorRef: (uid) => firebase.database().ref("operators/" + uid),
    // singleDriverStatusRef: (uid) => firebase.database().ref("driver_status/" + uid),
    // singleBookingRequestRef: (booking) => firebase.database().ref("bookingRequestedDrivers/" + booking),
    // profileImageRef: (uid) => firebase.storage().ref(`users/${uid}/profileImage`),
    // driverDocsRef: (uid, timestamp) => firebase.storage().ref(`users/${uid}/driverDocuments/${timestamp}/`),
    // operatorDocsRef: (uid, timestamp) => firebase.storage().ref(`users/${uid}/operatorDocuments/${timestamp}/`),
    // carTypeDocsRef: (type, role) => firebase.storage().ref(`rates/car_type/${type}/${role}/`),
    // vehiclesDocsRef: (type, timestamp) => firebase.storage().ref(`vehicles/${type}/${timestamp}/`),
    // singleBookingRef: (bookingKey) => firebase.database().ref("bookings/" + bookingKey),
    // requestedDriversRef: (bookingKey) => firebase.database().ref("bookings/" + bookingKey + "/requestedDrivers"),
    // walletBalRef: (uid) => firebase.database().ref("users/" + uid + "/walletBalance"),
    // walletHistoryRef: (uid) => firebase.database().ref("users/" + uid + "/walletHistory"),
    // referralIdRef: (referralId) => firebase.database().ref("users").orderByChild("referralId").equalTo(referralId),
    // trackingRef: (bookingId) => firebase.database().ref('tracking/' + bookingId),
    // tasksRef: () => firebase.database().ref('bookings').orderByChild('status').equalTo('NEW'),
    // singleTaskRef: (uid, bookingId) => firebase.database().ref("bookings/" + bookingId + "/requestedDrivers/" + uid),
    // bookingListRef: (uid, role) =>
    //     role == 'rider' ? firebase.database().ref('bookings').orderByChild('customer').equalTo(uid) :
    //         (role == 'driver' ?
    //         firebase.database().ref('bookings').orderByChild('driver').equalTo(uid)
    //             :
    //             (role == 'fleetadmin' ?
    //             firebase.database().ref('bookings').orderByChild('fleetadmin').equalTo(uid)
    //                 : firebase.database().ref('bookings')
    //             )
    //         ),
    // chatRef: (bookingId) => firebase.database().ref('chats/' + bookingId + '/messages'),
    // withdrawRef: firebase.database().ref('withdraws/'),

    api: {
        MinutesPassed: MinutesPassed,
        GetDateString: GetDateString,

        fetchCoordsfromPlace: fetchCoordsfromPlace,
        fetchAddressfromCoords: fetchAddressfromCoords,
        getDriveTime: getDriveTime,
        getRouteDetails: getRouteDetails,

        GetDistance: GetDistance,
        GetTripDistance: GetTripDistance,
        saveUserLocation: (uid, location) => firebase.database().ref('users/' + uid + '/location').set(location),
        saveTracking: (bookingId, location) => firebase.database().ref('tracking/' + bookingId).push(location),

        validateReferer: validateReferer,
        checkUserExists: checkUserExists,
        checkVehicleExists: checkVehicleExists,
        checkOperatorExists: checkOperatorExists,
        fetchUser: () => (dispatch) => fetchUser()(dispatch)(firebase),
        // fetchOperator: () => (dispatch) => fetchOperator()(dispatch)(firebase),
        // fetchVehicle: () => (dispatch) => fetchVehicle()(dispatch)(firebase),
        emailSignUp: (data) => emailSignUp(data)(firebase),
        mobileSignUp: (data) => mobileSignUp(data)(firebase),
        mobileUserCreate: (data) => mobileUserCreate(data)(firebase),
        mobileCheckOtp: (data) => mobileCheckOtp(data)(firebase),
        checkOtp: (code, otp, credential) => (dispatch) => checkOtp(code, otp, credential)(dispatch)(firebase),

        mobileSignIn: (verficationId, code) => (dispatch) => mobileSignIn(verficationId, code)(dispatch)(firebase),
        updatePassword: (password) => (dispatch) => updatePassword(password)(dispatch)(firebase),
        signIn: (email, password) => (dispatch) => signIn(email, password)(dispatch)(firebase),
        facebookSignIn: (token) => (dispatch) => facebookSignIn(token)(dispatch)(firebase),
        appleSignIn: (credentialData) => (dispatch) => appleSignIn(credentialData)(dispatch)(firebase),
        signOut: () => (dispatch) => signOut()(dispatch)(firebase),
        filterDriverStatus: (email, fromdate, todate) => (dispatch) => filterDriverStatus(email, fromdate, todate)(dispatch)(firebase),
        updateProfile: (userAuthData, updateData) => (dispatch) => updateProfile(userAuthData, updateData)(dispatch)(firebase),
        updateDriverStatus: (statusData, updateData) => (dispatch) => updateDriverStatus(statusData, updateData)(dispatch)(firebase),
        monitorProfileChanges: () => (dispatch) => monitorProfileChanges()(dispatch)(firebase),
        clearLoginError: () => (dispatch) => clearLoginError()(dispatch)(firebase),
        addBooking: (bookingData) => (dispatch) => addBooking(bookingData)(dispatch)(firebase),
        addRentalBooking: (bookingData) => (dispatch) => addRentalBooking(bookingData)(dispatch)(firebase),
        editBooking: (oldbookingData, bookingData) => (dispatch) => editBooking(oldbookingData, bookingData)(dispatch)(firebase),
        clearBooking: () => (dispatch) => clearBooking()(dispatch)(firebase),
        fetchFare: () => (dispatch) => fetchFare()(dispatch)(firebase),
        deleteFare: (uid) => (dispatch) => clearFare(uid)(dispatch)(firebase),
        updateFare: (fareData) => (dispatch) => updateFare(fareData)(dispatch)(firebase),
        fetchBookings: (uid, role) => (dispatch) => fetchBookings(uid, role)(dispatch)(firebase),
        fetchAllBookings: () => (dispatch) => fetchAllBookings()(dispatch)(firebase),
        updateBooking: (booking) => (dispatch) => updateBooking(booking)(dispatch)(firebase),
        cancelBooking: (data) => (dispatch) => cancelBooking(data)(dispatch)(firebase),
        fetchCancelReasons: () => (dispatch) => fetchCancelReasons()(dispatch)(firebase),
        editCancellationReason: (reasons, method) => (dispatch) => editCancellationReason(reasons, method)(dispatch)(firebase),
        fetchCarTypes: () => (dispatch) => fetchCarTypes()(dispatch)(firebase),
        // editCarType: (carTypes, method) => (dispatch) => editCarType(carTypes, method)(dispatch)(firebase),
        editCarType: (id, carTypes) => (dispatch) => editCarType(id, carTypes)(dispatch)(firebase),
        addCarType: (carTypesData, boundary) => (dispatch) => addCarType(carTypesData, boundary)(dispatch)(firebase),
        getEstimate: (bookingData, settings) => (dispatch) => getEstimate(bookingData, settings)(dispatch)(firebase),
        clearEstimate: () => (dispatch) => clearEstimate()(dispatch)(firebase),
        getRentalEstimate: (bookingData) => (dispatch) => getRentalEstimate(bookingData)(dispatch)(firebase),
        clearRentalEstimate: () => (dispatch) => clearRentalEstimate()(dispatch)(firebase),
        clearDriverEstimate: () => (dispatch) => clearDriverEstimate()(dispatch)(firebase),
        getDriverEstimate: (bookingData) => (dispatch) => getDriverEstimate(bookingData)(dispatch)(firebase),
        fetchSettings: () => (dispatch) => fetchSettings()(dispatch)(firebase),
        editSettings: (settings) => (dispatch) => editSettings(settings)(dispatch)(firebase),
        clearSettingsViewError: () => (dispatch) => clearSettingsViewError()(dispatch)(firebase),
        sendResetMail: (email) => (dispatch) => sendResetMail(email)(dispatch)(firebase),
        fetchDriverEarnings: (uid, role) => (dispatch) => fetchDriverEarnings(uid, role)(dispatch)(firebase),
        fetchEarningsReport: () => (dispatch) => fetchEarningsReport()(dispatch)(firebase),
        fetchNotifications: () => (dispatch) => fetchNotifications()(dispatch)(firebase),
        editNotifications: (notifications) => (dispatch) => editNotifications(notifications)(dispatch)(firebase),
        addNotifications: (notifications) => (dispatch) => addNotifications(notifications)(dispatch)(firebase),
        deleteNotifications: (notifications) => (dispatch) => deleteNotifications(notifications)(dispatch)(firebase),
        sendNotification: (notification) => (dispatch) => sendNotification(notification)(dispatch)(firebase),
        fetchPromos: () => (dispatch) => fetchPromos()(dispatch)(firebase),
        addPromo: (promos) => (dispatch) => addPromo(promos)(dispatch)(firebase),
        editPromo: (promos) => (dispatch) => editPromo(promos)(dispatch)(firebase),
        deletePromo: (promos) => (dispatch) => deletePromo(promos)(dispatch)(firebase),
        fetchUsers: () => (dispatch) => fetchUsers()(dispatch)(firebase),
        fetchTransactions: () => (dispatch) => fetchTransactions()(dispatch)(firebase),
        fetchOperators: () => (dispatch) => fetchOperators()(dispatch)(firebase),
        fetchVehicles: () => (dispatch) => fetchVehicles()(dispatch)(firebase),
        fetchDriverStatus: (email, start, end) => (dispatch) => fetchDriverStatus(email, start, end)(dispatch)(firebase),
        fetchDrivers: () => (dispatch) => fetchDrivers()(dispatch)(firebase),
        addLocalFare: (faredata) => (dispatch) => addLocalFare(faredata)(dispatch)(firebase),
        addOutstationFare: (faredata) => (dispatch) => addOutstationFare(faredata)(dispatch)(firebase),
        addRentalFare: (faredata) => (dispatch) => addRentalFare(faredata)(dispatch)(firebase),
        addUser: (userdata) => (dispatch) => addUser(userdata)(dispatch)(firebase),
        uploadImage: (userdata) => (dispatch) => uploadImage(userdata)(dispatch)(firebase),
        addOperator: (operatordata) => (dispatch) => addOperator(operatordata)(dispatch)(firebase),
        addTransaction: (transdata) => (dispatch) => addTransaction(transdata)(dispatch)(firebase),
        addVehicle: (vehicledata) => (dispatch) => addVehicle(vehicledata)(dispatch)(firebase),
        addDriverStatus: (statusdata) => (dispatch) => addDriverStatus(statusdata)(dispatch)(firebase),
        editDriverStatus: (email) => (dispatch) => editDriverStatus(email)(dispatch)(firebase),
        editUser: (id, user) => (dispatch) => editUser(id, user)(dispatch)(firebase),
        editTransaction: (id, trans) => (dispatch) => editTransaction(id, trans)(dispatch)(firebase),
        editOperator: (id, operator) => (dispatch) => editOperator(id, operator)(dispatch)(firebase),
        editVehicle: (id, vehicle) => (dispatch) => editVehicle(id, vehicle)(dispatch)(firebase),
        updateVehicleCommission: (id, vehicle) => (dispatch) => updateVehicleCommission(id, vehicle)(dispatch)(firebase),
        driverCancelBooking: (data) => (dispatch) => driverCancelBooking(data)(dispatch)(firebase),
        driverEditVehicle: (id, vehicle) => (dispatch) => driverEditVehicle(id, vehicle)(dispatch)(firebase),
        updatePushToken: (userAuthData, token, platform) => (dispatch) => updatePushToken(userAuthData, token, platform)(dispatch)(firebase),
        updateProfileImage: (userAuthData, imageBlob) => (dispatch) => updateProfileImage(userAuthData, imageBlob)(dispatch)(firebase),
        requestPhoneOtpDevice: requestPhoneOtpDevice,
        // requestPhoneOtpDevice: (phoneNumber, appVerifier) => (dispatch) => requestPhoneOtpDevice(phoneNumber, appVerifier)(dispatch)(firebase),
        deleteUser: (uid) => (dispatch) => deleteUser(uid)(dispatch)(firebase),
        deleteOperator: (uid) => (dispatch) => deleteOperator(uid)(dispatch)(firebase),
        deleteTransaction: (uid) => (dispatch) => deleteTransaction(uid)(dispatch)(firebase),
        deleteVehicle: (uid, driverId) => (dispatch) => deleteVehicle(uid, driverId)(dispatch)(firebase),
        deleteCarType: (uid) => (dispatch) => deleteCarType(uid)(dispatch)(firebase),
        fetchPaymentMethods: () => (dispatch) => fetchPaymentMethods()(dispatch)(firebase),
        addToWallet: (uid, amount) => (dispatch) => addToWallet(uid, amount)(dispatch)(firebase),
        updateWalletBalance: (balance, details) => (dispatch) => updateWalletBalance(balance, details)(dispatch)(firebase),
        clearMessage: () => (dispatch) => clearMessage()(dispatch)(firebase),
        updateTripPickup: (pickupAddress) => (dispatch) => updateTripPickup(pickupAddress)(dispatch)(firebase),
        updateTripDrop: (dropAddress) => (dispatch) => updateTripDrop(dropAddress)(dispatch)(firebase),
        updateTripCar: (selectedCar) => (dispatch) => updateTripCar(selectedCar)(dispatch)(firebase),
        updatSelPointType: (selection) => (dispatch) => updatSelPointType(selection)(dispatch)(firebase),
        clearTripPoints: () => (dispatch) => clearTripPoints()(dispatch)(firebase),
        fetchTasks: () => (dispatch) => fetchTasks()(dispatch)(firebase),
        acceptTask: (userAuthData, task) => (dispatch) => acceptTask(userAuthData, task)(dispatch)(firebase),
        cancelTask: (bookingId) => (dispatch) => cancelTask(bookingId)(dispatch)(firebase),
        fetchBookingLocations: (bookingId) => (dispatch) => fetchBookingLocations(bookingId)(dispatch)(firebase),
        stopLocationFetch: (bookingId) => (dispatch) => stopLocationFetch(bookingId)(dispatch)(firebase),
        fetchChatMessages: (bookingId) => (dispatch) => fetchChatMessages(bookingId)(dispatch)(firebase),
        sendMessage: (data) => (dispatch) => sendMessage(data)(dispatch)(firebase),
        stopFetchMessages: (bookingId) => (dispatch) => stopFetchMessages(bookingId)(dispatch)(firebase),
        fetchWithdraws: () => (dispatch) => fetchWithdraws()(dispatch)(firebase),
        bookingReq: (id) => (dispatch) => bookingReq(id)(dispatch)(firebase),
        completeWithdraw: (entry) => (dispatch) => completeWithdraw(entry)(dispatch)(firebase),
        resetPassword: resetPassword,
        addCancellationReason: (reasons, method) => (dispatch) => addCancellationReason(reasons, method)(dispatch)(firebase),
        deleteCancellationReason: (id, method) => (dispatch) => deleteCancellationReason(id, method)(dispatch)(firebase),
        fetchRequestedDrivers: fetchRequestedDrivers,
        getTrackingRecord: getTrackingRecord
    }
}

// export {
//     FirebaseContext,
//     FirebaseProvider,
//     store
// }

export default Firebase;